<template>
  <div class="info">
    <!-- 导航栏 -->
    <nav-header :href="this.href"></nav-header>

    <!-- 定宽 -->
    <div class="container">
      <!-- 右侧 内容 -->
      <div class="info-2">
        <h3>关于我们</h3>
        <!-- 下环线 -->
        <div class="bink"></div>

        <!-- banenr -->
        <div class="i2-banner">
          <img src="/imgs/us-banner.jpg" alt="" />
        </div>
        <div class="i2-con">
          <h3>公司名称：台州微趣网络技术有限公司</h3>
          <h3>联系邮箱：8039339@qq.com</h3>
          <h3>联系电话：15888661537</h3>
          <h3>ICP备案：浙ICP备19024521号-1</h3>
          <h3>公司地址：浙江省台州市椒江区洪家街道银泰城8幢2302室(仅限办公)</h3>
          <p>
           台州微趣网络技术有限公司成立于2016年07月25日，注册地位于浙江省台州市椒江区洪家街道银泰城8幢2302室(仅限办公)，经营范围包括软件和信息技术服务；利用互联网销售：电子产品、服装、文具；经营性互联网文化服务；多媒体设计服务；图文设计服务；动漫及衍生产品设计服务；大型活动组织策划服务；会议及展览服务；增值电信服务；出版物零售。（依法须经批准的项目，经相关部门批准后方可开展经营活动）。
          </p>
          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavHeader from "./../components/NavHeader";
export default {
  name: "info",
  components: {
    NavHeader,
  },
  data() {
    return {
      href: "/",
    };
  },
  mounted() {
      document.title = "微趣 ";
  },
  methods: {
    // 跳转关于我们
    goInfo() {
      this.$router.push("/info");
    },
    // 跳转注册协议
    goXy() {
      this.$router.push("/xy");
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";
.info {
  width: 100%;
  background-color: #f0f0f0;
  // banner
  .i2-banner {
    width: 100%;
    height: 250px;
    background-color: pink;
    margin-bottom: 120px;
    img {
      width: 100%;
      height: 100%;
    }
  }

  // 定宽布局
  .container {
    @include flex();
    // height: 800px;
    margin-bottom: 30px;
    // 左侧
    .info-1 {
      width: 30%;
      height: 100%;
      margin-right: 20px;
      // background-color: red;
      ul {
        width: 190px;
        background-color: #fff;
        border-bottom: 2px solid #dfe1e2;
        border-radius: 3px;
        padding: 13px 15px;
        margin: 0 auto;
        li {
          width: 90%;
          height: 40px;
          line-height: 40px;
          font-size: 14px;
          font-weight: bold;

          box-sizing: border-box;
          margin: 10px auto;
          cursor: pointer;
          padding-left: 20px;
          &.active {
            background-color: #3890e1;
            color: #fff;
          }
        }
      }
    }
    // 右侧
    .info-2 {
      width: 70%;
      height: 100%;
      background: #fff;
      padding: 40px;
      box-sizing: border-box;
      text-align: center;
      h3 {
        font-size: 24px;
      }
      // 下划线
      .bink {
        width: 30px;
        height: 3px;
        background-color: #000;
        margin: 10px auto;
      }

      // banner
      .i2-banner {
        width: 100%;
        height: 300px;
        background: url("/imgs/b1.jpg") no-repeat center;
        background-size: cover;
        margin: 30px auto;
      }

      // 文章
      .i2-con {
        p {
          font-size: 13px;
          line-height: 3.2em;
          color: #4e4b4b;
          margin: 15px auto;
          padding: 10px;
          box-sizing: border-box;
          text-align: left;
        }
        h3 {
          font-size: 18px;
          margin: 15px auto;
        }
      }
    }
  }
}
</style>
